import React, { Fragment } from 'react';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const Name = ({ fullName }) => <Fragment>{fullName}</Fragment>;

const NameWithPermissions = WithUserPermissions(Name);

const CustomerName = ({ customer: { fullName } = {} }) =>
  fullName && (
    <div className="cmm-modal-content-subgroup customer-name">
      <div className="cmm-modal-content-flex-container">
        <div className="cmm-modal-content-header-container">
          <div className="cmm-modal-content-header">Contact Name</div>
          <div className="cmm-modal-content-header-details">
            <NameWithPermissions fullName={fullName} shouldMask />
          </div>
        </div>
      </div>
    </div>
  );

export default CustomerName;
